import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkAuthenticated } from "../../actions/auth";
import { load_user_data_from_id } from "../../actions/user_content";
import CalendarContainer from "../../containers/CalendarContainer";
import CreateProfileModal from "../../containers/Modals/CreateProfileModal";
import { Button } from "react-bootstrap";
import ProfileDocumentList from "../../containers/Profiles/ProfileDocumentList";
import ProfileFinances from "../../containers/Profiles/ProfileFinances";

const MyProfile = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const perfilId = user.id;
  const [modalShow, setModalShow] = useState(false);
  const [infoCollapsed, setInfoCollapsed] = useState(true);
  const [userData, setUserData] = useState({
    id: perfilId,
    email: "",
    rut: "",
    name: "",
    first_lastname: "",
    second_lastname: "",
    phone: null,
    occupation: "",
    profile_type: "",
  });

  const fetchUserData = async () => {
    const data = await load_user_data_from_id(perfilId);
    if (data) {
      setUserData(data);
    }
  };

  useEffect(() => {
    dispatch(checkAuthenticated());
    fetchUserData();
  }, []);
  if (!user) {
    return <div>No tienes perfil</div>;
  }
  return (
    <div className="content">
      <div className="d-flex justify-content-between align-items-center page-title">
        <h1>Detalle Perfil {userData.name}</h1>
        <div className="d-flex gap-2 mx-2 h-50">
          <Button
            variant="primary d-flex align-items-center gap-2"
            onClick={() => setModalShow(true)}
          >
            <i className="bi bi-pencil-square"></i>Editar Datos
          </Button>
        </div>
      </div>
      <div className="personal-info-toggle">
        <Button
          variant="outline-secondary"
          onClick={() => setInfoCollapsed(!infoCollapsed)}
        >
          {infoCollapsed ? (
            <span>
              Ver Mas
              <i className="bi bi-arrow-down-square" />
            </span>
          ) : (
            <span>
              Ver Menos
              <i className="bi bi-arrow-up-square" />
            </span>
          )}
        </Button>
      </div>
      <div
        className={
          infoCollapsed
            ? "personal-info profile-info active"
            : "personal-info profile-info"
        }
      >
        <div className="d-flex align-items-center flex-column gap-1 info-section basic-info">
          <div className="section-title">
            <h2 className="text-center">
              {userData.name} {userData.first_lastname}
            </h2>
          </div>
          <span>
            Cargo:
            <strong className="px-2">{userData.occupation}</strong>
          </span>
        </div>
        <div className="d-none d-lg-flex">
          <div className="vr"></div>
        </div>
        <div className="info-section general-info">
          <div className="section-title">
            <h5 className="text-center">Información</h5>
          </div>

          <div className="general-info-fields">
            <div className="two-col-field">
              <div className="info-field">
                <span>Nombre Completo</span>
                <strong>
                  {userData.name} {userData.first_lastname}{" "}
                  {userData.second_lastname}
                </strong>
              </div>
              <div className="info-field">
                <span>Email</span>
                <strong>{userData.email}</strong>
              </div>
            </div>
            {userData.phone && (
              <div className="info-field w-100">
                <span>Telefono</span>
                <strong>{userData.phone}</strong>
              </div>
            )}
            <div className="two-col-field optional-info">
              <div className="info-field">
                <span>Tipo Perfil</span>
                <strong>{userData.profile_type}</strong>
              </div>
              <div className="col info-field">
                <span>Fecha de Registro</span>
                <strong>{userData.date_registered}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="calendar-app pb-4">
        <div className="d-flex justify-content-center">
          <h3>Agenda</h3>
        </div>
        <CalendarContainer profileId={perfilId} />
      </div>
      <ProfileFinances profileId={perfilId} />
      <div className="ev-doc-lists">
        <ProfileDocumentList profileId={perfilId} />
      </div>
      <CreateProfileModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        profileId={perfilId}
        userData={userData}
      />
    </div>
  );
};

export default MyProfile;
